<template>
  <v-app id="mfaKeyCreateApp">
    <header-item />

    <v-content>
      <v-container>
        <v-row
          dense
          align="center"
          max-width="100"
        >
          <v-col
            cols="12"
            sm="12"
            md="12"
            align="center"
          >
            <h2>クラウドフォルダー ワンタイムパスワード認証設定</h2>
          </v-col>
        </v-row>
        
        <v-stepper v-model="e1">
          <v-stepper-header>
            <template v-for="n in stepDef">
              <v-stepper-step
                :key="`${n.index}-step`"
                :complete="e1 > n.index"
                :step="n.index"
              >
                {{ n.title }}
              </v-stepper-step>
  
              <v-divider
                v-if="n.index !== stepDef.length"
                :key="n.index"
              />
            </template>
          </v-stepper-header>
          <v-stepper-items>
            <template v-for="n in stepDef">
              <v-stepper-content
                :key="`${n.index}-step`"
                :step="n.index"
              >
                <div v-if="n.index == 1">
                  <v-card
                    color="lighten-1"
                    flat
                  >
                    <v-row align="center">
                      <!-- ログイン確認説明 -->
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="12"
                        xl="12"
                        align="center"
                      >
                        <div>
                          クラウドフォルダーのワンタイムパスワード認証を設定します。
                        </div>
                        <div>
                          本人確認のため、ログインしてください。
                        </div>
                      </v-col>
                      <!-- ログイン確認説明 -->
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="12"
                        xl="12"
                        align="center"
                      >
                        <!-- ワンタイムパスワード認証説明画面-->
                        <mfa-description />
                      </v-col>
                      <!-- ユーザID -->
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                      />
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="8"
                        xl="8"
                      >
                        <v-text-field
                          v-model="userId"
                          required
                          disabled
                          readonly
                          prepend-icon="mdi-account-circle"
                          label="ユーザーID"
                          placeholder=" "
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                      />
                      <!-- パスワード -->
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                      />
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="8"
                        xl="8"
                      >
                        <v-text-field
                          v-model="userPass"
                          required
                          type="password"
                          prepend-icon="mdi-lock"
                          label="パスワード"
                          placeholder=" "
                          maxlength="256"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="2"
                        xl="2"
                      />
                    </v-row>
                    <v-row align="center">
                      <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="12"
                        lg="12"
                        xl="12"
                        align="center"
                      >
                        <v-btn
                          color="primary"
                          :loading="loading"
                          :disabled="loading"
                          @click="nextStepCheck(Number(`${n.index}`));"
                        >
                          ログイン
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
                <div v-if="n.index == 2">
                  <!-- ワンタイムパスワード認証初期設定画面-->
                  <mfa-setting
                    ref="MfaSetting"
                    :index="Number(`${n.index}`)"
                    :user-id="userId"
                    :user-pass-cf="userPass"
                    :mfaflg="mfaflg"
                    :mobile-flg="mobileFlg"
                    @clickNext="setMfaOnetimepass($event, mfaSettingResult)"
                  />
                </div>
                <div v-if="n.index == 3">
                  <v-card
                    color="lighten-1"
                    flat
                  >
                    <v-row
                      dense
                      max-width="100"
                    >
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <span>
                          ワンタイムパスワード認証設定が完了しました。ログインが可能になります。
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          color="primary"
                          @click="nextStepCheck(Number(`${n.index}`));"
                        >
                          ログイン画面へ
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </v-stepper-content>
            </template>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-content>
    <msg-dlg ref="MsgDlg" />
  </v-app>
</template>

<script>

import HeaderItem from './HeaderItem.vue'
import Amplify, {isMobile, Constant, RestApiUtil, Logger} from '../amplify_com.js';
import MsgDlg from './MsgDlg.vue';
import MfaDescription from './MfaDescription.vue';
import MfaSetting from './MfaSetting';

export default {  
  components: {
    'header-item': HeaderItem,
    'msg-dlg': MsgDlg,
    'mfa-description': MfaDescription,
    'mfa-setting': MfaSetting,
  },
  data: () => ({
    Constant :Constant, // template内で定数クラスを使用するため
    // ステップ定義
    stepDef: [
      { 
        index : 1,
        title : 'ログイン確認', 
        checkFunc: async function(app){
          if(!app.userId){
            app.$refs.MsgDlg.showError('ユーザーIDを入力してください');
            return false;
          }

          if(!app.userPass){
            app.$refs.MsgDlg.showError('パスワードを入力してください');
            return false;
          }

          // ログイン
          app.loading = true;
          let _result = false;
          await Amplify.Auth.signIn(
            {
                username : app.userId,
                password : app.userPass,
                validationData: {
                  input_username: app.userId,
                },
            }
          ).then(() => {
            _result = true;
          }).catch(err => {
            app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
            app.loading = false;
          });

          if(!_result){
            app.loading = false;
            return false;
          }
          app.loading = false;
          return _result;
        },
        okFunc: function(app, now_index){
          // MFA設定画面 初期化
          app.$refs.MfaSetting[0].init();
          app.nextStep(now_index + 1);
        },
      },
      { 
        index : 2,
        title : 'ワンタイムパスワード認証 設定', 
        checkFunc: async function(app){
          // mfa認証あり ワンタイムパスワード入力なし
          if(app.mfaflg && !app.mfaOnetimepass){
            app.$refs.MsgDlg.showError('ワンタイムパスワードを入力してください');
            app.$refs.MfaSetting[0].setLoadingOneTime();
            return false;
          }
          return true;
        },
        okFunc: function(app, now_index){
          // mfa認証あり
          if(app.mfaflg){
            Amplify.Auth.signIn(
              {
                  username : app.userId,
                  password : app.userPass,
                  validationData: {
                    input_username: app.userId,
                    mfa_type : app.mfaflg ? Constant.UserMfa.Setting : Constant.UserMfa.Off,
                  },
              }
            ).then(user => {
              let _user = user;
              Amplify.Auth.verifyTotpToken(
                _user,
                app.mfaOnetimepass,
              ).then(() => {
                Amplify.Auth.setPreferredMFA(
                  _user,
                  'TOTP'
                ).then(() => {
                  app.$refs.MsgDlg.showModalSuccess('ワンタイムパスワード認証に成功しました。');
                  // 次へ
                  app.nextStep(now_index + 1);
                  app.$refs.MfaSetting[0].setLoadingOneTime();
                }).catch(err => {
                  app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
                  app.$refs.MfaSetting[0].setLoadingOneTime();
                });
              }).catch(err => {
                app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
                app.$refs.MfaSetting[0].setLoadingOneTime();
              });
            }).catch(err => {
              app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
              app.$refs.MfaSetting[0].setLoadingOneTime();
            });
          } else {
            // 次へ
            app.nextStep(now_index + 1);
            app.$refs.MfaSetting[0].setLoadingOneTime();
          }
        },
      },
      { 
        index : 3,
        title : '完了', 
        checkFunc: async function(){
          return true;
        },
        okFunc: function(app, now_index){
          // 次へ
          app.nextStep(now_index + 1);
        },
      },
    ],
    e1: 1,
    steps: 3,
    userId: '',
    userPass: '',
    mfaflg: false,
    userAuthType: '',
    userType: '',
    mfaOnetimepass: '',
    mobileFlg: isMobile.any,
    loading: false,
  }),
  watch: {
    steps (val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },
  },
  beforeCreate : function () {
    // 念のため、サインしているならサインアウト
    Amplify.Auth.currentUserPoolUser().then(() => {
        Amplify.Auth.signOut();
    }).catch(err => {
      // エラー発生しても無視
      Logger.log(err);
    });

    // キーチェック
    let _this = this;
    if(_this.$route.query.key){
      let key = _this.$route.query.key;
      // キーチェックrestAPIを実施。
      RestApiUtil.PostMailTokenAuth(key).then(mailTokenAuth => {
        // チェック
        if(!(mailTokenAuth.next_url.endsWith(key))){
          // この画面を表示する権限がないので戻る
          _this.$router.push({ path: "/" }, () => {}, () => {});
        }
        // apiから取得した初期データを画面に設定
        _this.mfaflg = mailTokenAuth.mfaflg === Constant.UserMfa.Setting ? true : false;
        _this.userAuthType = parseInt(mailTokenAuth.user_auth_type);
        _this.userType = parseInt(mailTokenAuth.user_type);
        _this.userId = mailTokenAuth.preferred_user_name ? mailTokenAuth.preferred_user_name : mailTokenAuth.user_name;
      }).catch(() => {
        // この画面を表示する権限がないので戻る
        _this.$router.push({ path: "/" }, () => {}, () => {});
      });
    } else {
      // この画面を表示する権限がないので戻る
      _this.$router.push({ path: "/" }, () => {}, () => {});
    }
  },
  mounted() {
    //戻るボタン無効化
    history.pushState(null, null, null);
    window.addEventListener("popstate", function () {
      history.pushState(null, null, null);
      return;
    });
  },
  methods: {
    nextStepCheck : async function(n) {
      var curDef = this.stepDef[n-1];
      if(await curDef.checkFunc(this)){
        curDef.okFunc(this, n);
      }
    },
    nextStep (n) {
      if (n === this.steps + 1) {
        // 次のステップはないのでログイン画面へ遷移
        this.$router.push({ path: "/" }, () => {}, () => {});
      } else {
        this.e1 = n
      }
    },
    // MFA初期設定画面からのコールバック
    setMfaOnetimepass(mfaSettingResult){
      this.mfaOnetimepass = mfaSettingResult.mfaOnetimepass;
      this.nextStepCheck(mfaSettingResult.index);
    },
  }
};
</script>

<style>
.v-application--wrap {min-height:0;}
</style>